import React from "react";
import { Container, Row, Col } from "shards-react";
import AdminPanelIndex from "../../components/adminpanel";

import PageTitle from "../../components/common/PageTitle";
import FooterComponent from "../../components/Footer/FooterComponent";
import FrontendHomeComponent from "../../components/frontend";
import ParticipantIndex from "../../components/frontend/participantIndex";
import HeaderComponent from "../../components/Header/headerComponent";
import ProductsIndex from "../../components/products";



const ParticipantView = (props) => (
    <div>
    <HeaderComponent/>
    <ParticipantIndex  data={props.location.data}/>
    <FooterComponent/>
    
    </div>
);

export default ParticipantView;
